import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormAdd = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormAdd' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,18 L12,6 M6,12 L18,12' />
  </StyledIcon>
);
